export const globalStyles = {
  styles: {
    global: {
      'html, body': {
        background: '#fafafa',
      },
    },
  },
};
